import React from 'react';
import { useOffices } from 'redux/models/offices/hooks';
import { Page } from 'theme/components/Layout/Layout';
import OfficePageContent from './OfficePageContent/OfficePageContent';
import Message from 'theme/components/Message';
import Loader from 'theme/components/Loader/Loader';

const ErrorMessage = () => (
  <Message>
    Извините, произошла ошибка. Попробуйте перезагрузить страницу
  </Message>
);

const OfficePage = () => {
  const { offices, isError, isLoading, isLoaded } = useOffices();

  switch (true) {
    case isLoading:
      return <Loader />;
    case isLoaded:
      return (
        <Page>
          <OfficePageContent offices={offices} />
        </Page>
      );
    case isError:
      return <ErrorMessage />;
    default:
      return <Loader />;
  }
};

export default OfficePage;
